module.exports = __webpack_public_path__ + "img/schedule.fa506fda.svg";